import { EXTERNAL_PRODUCT_ORDER_TYPE } from '../constants';

/**
 * Lines of an order from `En préparation` onwards, one per product: the ordered quantity (BDC) of
 * the `to_prepare` line, next to the delivered one (BDL) of its `prepared` sibling. The BDL was
 * initialized server-side as a copy of the BDC when the preparation started — the front never
 * pre-fills it — but an order entered in preparation before that rule can carry no BDL line: such
 * a line falls back on a BDL of 0, unchecked.
 *
 * The price and the VAT rate were frozen on the lines at validation and stay identical between the
 * two types, so the BDC line hands them over for the whole row.
 *
 * @param {Array<Object>} products - The product orders of the order, whatever their type
 *
 * @returns {Array<Object>} One line per ordered product, with its BDL quantity and preparer tick
 */
export const buildPreparationOrderProductLines = (products) => {
  const preparedLineByProductId = (products ?? []).reduce((preparedLines, product) => {
    if (product.type === EXTERNAL_PRODUCT_ORDER_TYPE.PREPARED) {
      preparedLines[product.productId] = product;
    }

    return preparedLines;
  }, {});

  return (products ?? [])
    .filter(({ type }) => type === EXTERNAL_PRODUCT_ORDER_TYPE.TO_PREPARE)
    .map((product) => {
      const preparedLine = preparedLineByProductId[product.productId];

      return {
        ...product,
        preparedQuantity: preparedLine?.quantity ?? 0,
        checked: preparedLine?.checked ?? false,
      };
    });
};
